<template>
  <Content :error="error" :loading="loading" :length-ads="adsCount">
    <Card v-for="(tutorial, tutorialIndex) in tutorials" :key="tutorialIndex">
      <GcAdsenseCard
        v-if="tutorial.isAd"
        :slot-id="tutorial.slotId"
      ></GcAdsenseCard>
      <Tutorial v-else :tutorial="tutorial"></Tutorial>
    </Card>
  </Content>
</template>

<script>
import Tutorial from "../cards/Tutorial";
import GcAdsenseCard from "../../../../shared/adsense/GcAdsenseCard";
import Card from "../shared/Card";
import Content from "../shared/Content";

export default {
  name: "Tutorials",
  components: {
    Card,
    Tutorial,
    GcAdsenseCard,
    Content
  },
  props: {
    tutorials: {
      default() {
        return [];
      },
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  computed: {
    error() {
      if (!this.loading && this.tutorials.length < 1) {
        return {
          message: "No activity to display",
          link: null
        };
      } else {
        return {
          message: null,
          link: null
        };
      }
    },
    adsCount() {
      return this.tutorials.filter(tutorial => tutorial.isAd).length;
    }
  }
};
</script>
